import { getAuthUserId } from '@library/auth'
import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  setMethod,
  setQueryParams,
  setServiceUrl,
} from '@library/http/requests'

import type { RecipeUUID } from '../../internal/types'

import type { MenuRecipeTileResponse } from './types'

type MenuRecipeTileNumPortions = 1 | 2 | 3 | 4 | 5

export type MenuRecipeTileRequestParams = {
  menuId: string
  recipeId: RecipeUUID
  numPortions: MenuRecipeTileNumPortions
  deliveryDate?: string
}

const menuApiRecipeTileParse = async (response: Response): Promise<MenuRecipeTileResponse> => {
  const body = await response.text()
  const parsedBody = JSON.parse(body)

  if (!response.ok) {
    throw new Error(parsedBody.error ?? parsedBody.message)
  }

  return parsedBody as MenuRecipeTileResponse
}

const menuApiRecipeTileRequest = composeRequest(
  setServiceUrl('menu', 3),
  addPath(
    ({ menuId, recipeId }: MenuRecipeTileRequestParams) =>
      `menus/${menuId}/recipe-tiles/${recipeId}`,
  ),
  setQueryParams(({ deliveryDate, numPortions }: MenuRecipeTileRequestParams) => {
    const userId = getAuthUserId()

    return {
      ...(deliveryDate && { delivery_date: deliveryDate }),
      num_portions: numPortions.toString(),
      ...(userId && { user_id: userId }),
    }
  }),
  setMethod('GET'),
  goustoHeaders,
)

export const menuRecipeTileFetcher = composeFetch(menuApiRecipeTileRequest, menuApiRecipeTileParse)
